import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, User } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { motion } from 'framer-motion';
import { useBlogPosts } from '../../hooks/useBlogPosts';
export function BlogPreviewSection() {
  const {
    posts
  } = useBlogPosts();
  const BLOG_POSTS = posts.slice(0, 3);
  return <section className="py-20 bg-white" data-id="element-465">
      <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-466">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-467">
          <div className="max-w-2xl" data-id="element-468">
            <motion.span initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-[#FF6600] font-semibold tracking-wide uppercase text-sm" data-id="element-469">
              Our Insights
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-3xl md:text-4xl font-bold text-[#0C0C0C] mt-2" data-id="element-470">
              Latest from the blog
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-gray-600 mt-4 text-lg" data-id="element-471">
              Thoughts, trends, and strategies from our team of digital experts.
            </motion.p>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-472">
            <Link to="/blog" data-id="element-473">
              <Button variant="outline" className="hidden md:inline-flex group" data-id="element-474">
                View All Articles
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-475" />
              </Button>
            </Link>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-476">
          {BLOG_POSTS.map((post, index) => <motion.div key={post.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1 + 0.2
        }} data-id="element-477">
              <Link to={`/blog/${post.slug}`} className="block h-full" data-id="element-478">
                <Card className="h-full flex flex-col p-0 overflow-hidden group cursor-pointer border-gray-100 hover:border-blue-100 transition-colors" data-id="element-479">
                  <div className="relative h-48 overflow-hidden" data-id="element-480">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-481" />
                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-[#00316B]" data-id="element-482">
                      {post.category}
                    </div>
                  </div>

                  <div className="p-6 flex flex-col flex-1" data-id="element-483">
                    <div className="flex items-center text-xs text-gray-500 mb-4 space-x-4" data-id="element-484">
                      <div className="flex items-center" data-id="element-485">
                        <Calendar className="w-3 h-3 mr-1" data-id="element-486" />
                        {post.date}
                      </div>
                      <div className="flex items-center" data-id="element-487">
                        <User className="w-3 h-3 mr-1" data-id="element-488" />
                        {post.author}
                      </div>
                    </div>

                    <h3 className="text-xl font-bold text-[#0C0C0C] mb-3 group-hover:text-[#00316B] transition-colors line-clamp-2" data-id="element-489">
                      {post.title}
                    </h3>

                    <p className="text-gray-600 text-sm mb-6 line-clamp-3 flex-1" data-id="element-490">
                      {post.excerpt}
                    </p>

                    <div className="flex items-center text-[#FF6600] font-medium text-sm mt-auto group-hover:underline" data-id="element-491">
                      Read Article
                      <ArrowRight className="ml-2 w-3 h-3 transition-transform group-hover:translate-x-1" data-id="element-492" />
                    </div>
                  </div>
                </Card>
              </Link>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-493">
          <Link to="/blog" data-id="element-494">
            <Button variant="outline" className="w-full group" data-id="element-495">
              View All Articles
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-496" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}